import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  content: {
    padding: '24px',
    margin: '-32px -40px',
    backgroundColor: "".concat(palette.shades[100])
  },
  caption: {
    marginBottom: '20px'
  },
  modalTrigger: {
    color: "".concat(palette.primary.main),
    cursor: 'pointer'
  },
  table: {
    borderTop: "1px solid ".concat(palette.shades[300]),
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& .MuiTableContainer-root': {
      boxShadow: 'none'
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
      padding: '10px 5px'
    },
    '& .MuiTableCell-root:first-of-type': {
      paddingLeft: '0'
    },
    '& .MuiTableRow-root.active': {
      backgroundColor: "".concat(palette.shades[200])
    }
  }
});
export default useStyles;